const ROOT = "[data-admin-drawer-search]";
const INPUT = "[data-admin-drawer-search-input]";
const CLEAR = "[data-admin-drawer-search-clear]";
const ITEM = "[data-admin-drawer-search-item]";
const EMPTY = "[data-admin-drawer-search-empty]";

function normalize(value: string): string {
  return value.trim().toLocaleLowerCase();
}

export function initAdminDrawerSearch(): void {
  const root = document.querySelector<HTMLElement>(ROOT);
  if (!root) return;

  const drawer = root.closest<HTMLElement>(".admin-drawer__figma");
  const input = root.querySelector<HTMLInputElement>(INPUT);
  const clear = root.querySelector<HTMLButtonElement>(CLEAR);
  if (!drawer || !input) return;

  const items = Array.from(drawer.querySelectorAll<HTMLElement>(ITEM));
  const empty = drawer.querySelector<HTMLElement>(EMPTY);

  const apply = (): void => {
    const query = normalize(input.value);
    root.classList.toggle("has-query", query !== "");
    if (clear) {
      clear.hidden = query === "";
    }
    let visibleCount = 0;

    items.forEach((item) => {
      const haystack = normalize(item.dataset.adminDrawerSearchText ?? item.textContent ?? "");
      const visible = query === "" || haystack.includes(query);
      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (empty) {
      empty.hidden = query === "" || visibleCount > 0;
    }
  };

  input.addEventListener("input", apply);
  clear?.addEventListener("click", () => {
    input.value = "";
    apply();
    input.focus({ preventScroll: true });
  });
  input.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || input.value === "") return;
    input.value = "";
    apply();
  });
}
